// light = placed on a navy background (white wordmark); compact = mark only on small screens
export const Logo = ({ light = true, compact = false, className = "h-8" }) => (
  <div className="flex items-center" data-testid="app-logo">
    {compact && <img src={light ? "/brand/vavlis-mark-white.png" : "/brand/vavlis-mark.png"} alt="Vavlis" className="h-9 w-auto sm:hidden" />}
    <img src={light ? "/brand/vavlis-logo-white-notag.png" : "/brand/vavlis-logo-transparent-notag.png"} alt="Vavlis — Premium Business Solutions"
      className={`${className} w-auto ${compact ? "hidden sm:block" : ""}`} />
  </div>
);
